module.exports = __webpack_public_path__ + "img/hero-6.7f03e980.png";